export class TreasuryFullModulePaymentSourceDetail {
  code?: string;
  transferFilter?: string;
  amount?: number;
  intervalAmount?: number;
  totalRecords?: number;
  intervalTotalRecords?: number;
}

export class TreasuryFullModuleSummaryResponseDto {
  businessEntityId: number;
  amount?: number;
  intervalAmount?: number;
  totalRecords?: number;
  intervalTotalRecords?: number;
  transferTypeDetails?: TreasuryFullModulePaymentSourceDetail[];
}
